export default __webpack_public_path__ + "static/Book_lover-00a687f374d613a4bcea0f6837c1da9e.svg";